import React from "react"
import.meta.env.REACT_APP_VERSION
import * as Sentry from "@sentry/react"
import afterFrame from "afterframe"
import { isMobile } from "../utils/detectDevice"
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom"

window.APP_VERSION = import.meta.env.REACT_APP_VERSION || "undefined"

window.APP_ENVIRONMENT = import.meta.env.REACT_APP_ENV_NAME || "undefined"

const SENTRY_URL_BLACKLIST: string[] = [
  "cloudfront.net/v1/b",
  "https://tiles.openfreemap.org",
]

Sentry.init({
  enabled:
    window.APP_ENVIRONMENT !== "undefined" &&
    window.APP_ENVIRONMENT !== "development",
  dsn: isMobile
    ? "https://670762dab96ddb311f62f8821c051fcd@o4506671058976768.ingest.us.sentry.io/4507057244012544"
    : "https://380368574f7f7bf3399fee4dedbbe4da@o4506671058976768.ingest.sentry.io/4506671061467136",
  transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
  release: window.APP_VERSION,
  environment: window.APP_ENVIRONMENT,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      // Additional SDK configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: window.APP_ENVIRONMENT === "production" ? 0.01 : 0.25,
  // Session Replay
  replaysSessionSampleRate:
    window.APP_ENVIRONMENT === "production" ? 0.01 : 0.2,
  replaysOnErrorSampleRate: 0.5,
  beforeSendTransaction: (event) => {
    if (event.spans) {
      event.spans = event.spans.filter((span) => {
        if (span.op === "http.client") {
          const url = span.description || "" // format "POST https://example.com/api/endpoint"
          for (const blacklist of SENTRY_URL_BLACKLIST) {
            if (url.includes(blacklist)) {
              return false
            }
          }
        }
        return true
      })
    }
    return event
  },
})
